module.exports = __webpack_public_path__ + "img/annoyance.4eefea02.svg";